import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { GetCompanyInformationResponse, HttpResponse } from "@/types";

export const companyInformationQueryKey = (companyId: string) =>
  ["company_information", companyId] as const;

export function useGetCompanyInformation() {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    queryKey: companyInformationQueryKey(currentCompanyId),
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/company-information`;
      const res = await guacHttpClient.get<
        GetCompanyInformationResponse,
        HttpResponse<GetCompanyInformationResponse>
      >(path);
      return res.data;
    },
  });
}
